function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.79 7.3V3.8h2.868a4.29 4.29 0 0 1 4.26-3.8 4.302 4.302 0 0 1 4.261 3.8h3.04v3.5c0 .137-.12.248-.248.248H9.029a.246.246 0 0 1-.24-.248z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M27.282 3.8h-2.92v1.143h-.025c.017.077.026.163.026.248V7.3c0 .768-.624 1.392-1.392 1.392H9.029A1.392 1.392 0 0 1 7.637 7.3V5.19c0-.085.008-.17.026-.248h-.026V3.8h-2.92a2.24 2.24 0 0 0-2.245 2.237v23.719A2.248 2.248 0 0 0 4.717 32h22.565a2.248 2.248 0 0 0 2.246-2.245V6.036A2.241 2.241 0 0 0 27.282 3.8zm-2.185 11.175L14.04 26.023a.811.811 0 0 1-.614.257.899.899 0 0 1-.632-.257l-5.891-5.968a.876.876 0 0 1 0-1.238l1.366-1.357c.324-.333.896-.333 1.23 0l3.927 3.919 9.059-9.059a.863.863 0 0 1 .623-.256c.23 0 .46.094.623.265l1.366 1.417a.868.868 0 0 1 0 1.23z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M24.363 4.943v.248c0-.085-.009-.17-.026-.248h.026zM7.663 4.943a1.132 1.132 0 0 0-.026.248v-.248h.026z"
});

var SvgIFullvalidation = function SvgIFullvalidation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIFullvalidation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/i_fullvalidation.04d00e0a.svg";
export { ForwardRef as ReactComponent };